const install = (Vue, vm) => {
  let api = {};

  // 首页一级岗位菜单
  api.getJobOneList = (params = {}) =>
    vm.$u.post("/api/job/job_first_list", params);
  // 首页一级岗位菜单
  api.saveJobOneList = (params = {}) =>
    vm.$u.post("/api/user/config_job_menu", params);
  // 套餐暂停弹窗
  api.userOpenVIP = (params = {}) => vm.$u.post("/api/user/open_vip", params);
  //全局配置
  api.cate = (params = {}) => vm.$u.post("/api/common/cate", params);
  api.getSetting = (params = {}) => vm.$u.post("/api/setting/info", params);
  //系统信息R
  api.system = (params = {}) => vm.$u.post("/api/common/system", params);
  //根据域名获取地址
  api.hostCity = (params = {}) => vm.$u.post("/api/common/host_city", params);
  api.shareConfig = (params = {}) =>
    vm.$u.post("/api/share_config/index", params);
  //根据ip获取地址
  api.ipCity = (params = {}) => vm.$u.post("/api/common/ip_city", params);
  //获取站点的网页配置
  api.webInfo = (params = {}) => vm.$u.post("/api/site/web_info", params);
  //获取g功能配置
  api.funSetting = (params = {}) =>
    vm.$u.post("/api/setting/getCommonConfigs", params);
  api.buzInfo = (params = {}) => vm.$u.post("/api/site/buz_config", params);
  // 站点列表
  api.getSiteList = (params = {}) =>
    vm.$u.post("/api/common/site_tree_list", params);
  //站点切换
  api.changeSite = (params = {}) =>
    vm.$u.post("/api/common/change_site", params);
  //站点对应子地区列表
  api.getRegionChildList = (params = {}) =>
    vm.$u.post("/api/region/child_list", params);
  // 发送短信
  api.sendSms = (params = {}) => vm.$u.post("/api/common/send_sms", params);
  //支付
  api.orderPay = (params = {}) => vm.$u.post("/api/order/order_pay", params);
  // 获取二维码
  api.getQcode = (params = {}) =>
    vm.$u.post("/api/site/weixin_group_code", params);
  // 清楚 jwt
  api.clearToken = (params = {}) =>
    vm.$u.post("/api/common/clearJwtTokenInBlackList", params);
  // 获取通用设置
  api.getUserConfig = (params = {}) =>
    vm.$u.post("/api/site/get_user_config", params);

  // 注册
  api.register = (params = {}) => vm.$u.post("/api/register/index", params);
  // 登陆
  api.login = (params = {}) => vm.$u.post("/api/login/login", params);
  //图片验证码
  api.imgCode = (params = {}) => vm.$u.post("/api/common/img_code", params);
  // 短信登陆
  api.smsLogin = (params = {}) => vm.$u.post("/api/login/sms_login", params);
  //小程序登陆
  api.miniLogin = (params = {}) => vm.$u.post("/api/login/mini_login", params);
  //小程序获取手机号
  api.miniPhone = (params = {}) => vm.$u.post("/api/login/mini_phone", params);
  //code换key--第三方
  api.weixinLogin = (params = {}) =>
    vm.$u.post("/api/login/weixin_login", params);
  //检查微信环境
  api.wxconfig = (params = {}) =>
    vm.$u.post("/api/common/weixin_jssdk_config", params);
  //检查token是否过期
  api.checkToken = (params = {}) =>
    vm.$u.post("/api/common/token_validate", params);
  //修改手机号
  api.changePhone = (params = {}) =>
    vm.$u.post("/api/login/change_phone", params);
  //修改密码
  api.changePassword = (params = {}) =>
    vm.$u.post("/api/login/change_password", params);
  // 绑定小程序
  api.bindMini = (params = {}) =>
    vm.$u.post("/api/user/bind_mini_authorize", params);
  // 绑定公众号
  api.bindGzh = (params = {}) =>
    vm.$u.post("/api/user/bind_wehcat_authorize", params);

  // 我的
  //----------------//
  api.changeUsername = (params = {}) =>
    vm.$u.post("/api/login/change_username", params);
  api.checkAccountExist = (params = {}) =>
    vm.$u.post("/api/login/check_account_exist", params);
  //我的信息
  api.userInfo = (params = {}) => vm.$u.post("/api/user/info", params);
  //用户信息修改
  api.editUserInfo = (params = {}) => vm.$u.post("/api/user/edit_info", params);
  //反馈
  api.feedback = (params = {}) => vm.$u.post("/api/user/report", params);
  // 账号解绑
  api.acountUnbind = (params = {}) =>
    vm.$u.post("/api/user/unbind_wechat", params);
  // 账号绑定
  api.accountBind = (params = {}) => vm.$u.post("", params);

  api.bindWeChatCode = (params = {}) =>
    vm.$u.post("/api/user/bind_wehcat_qcode", params);
  api.checkBind = (params = {}) =>
    vm.$u.post("/api/user/check_bind_wx", params);
  api.getQyPhoneRules = (params = {}) =>
    vm.$u.post("/api/user_setting/view_qy_phone_rules", params);

  // 首页地区导航
  api.getAreaNaves = (params = {}) =>
    vm.$u.post("/api/article/areaNavs", params);
  api.getLevel2Tree = (params = {}) =>
    vm.$u.post("/api/region/getLevel2Tree", params);

  // 地区列表
  api.getAreaList = (params = {}) =>
    vm.$u.post("/api/region/tree_list", params);
  // 公告列表
  api.getArticleList = (params = {}) => vm.$u.post("/api/article/list", params);
  // 公告详情
  api.getArticleDetail = (params = {}) =>
    vm.$u.post("/api/article/detail", params);
  // 公告纠错
  api.articleError = (params = {}) => vm.$u.post("/api/article/report", params);
  // 关注公告
  api.articleFollow = (params = {}) =>
    vm.$u.post("/api/article/follow", params);
  // 我的关注公告列表
  api.getArticleFollows = (params = {}) =>
    vm.$u.post("/api/article/my_follows", params);
  api.getCustomerService = (params = {}) =>
    vm.$u.post("/api/common/customer_service", params);
  api.getRecruitList = (params = {}) => vm.$u.post("/api/recruit/list", params);
  api.getLatestRecruitList = (params = {}) =>
    vm.$u.post("/api/recruit/latest", params);
  api.getRecruitDetail = (params = {}) =>
    vm.$u.post("/api/recruit/detail", params);
  api.collectRecruit = (params = {}) =>
    vm.$u.post("/api/recruit/collect", params);
  api.getMyCollects = (params = {}) =>
    vm.$u.post("/api/recruit/my_collects", params);
  api.getRootRegion = (params = {}) =>
    vm.$u.post("/api/region/getRootRegion", params);
  api.getMajorTree = (params = {}) =>
    vm.$u.post("/api/common/majorTree", params);
  api.myResume = (params = {}) =>
    vm.$u.post("/api/resume_user/my_resume", params);
  api.saveBasicInfo = (params = {}) =>
    vm.$u.post("/api/resume_user/saveBasicInfo", params);
  api.search_school = (params = {}) =>
    vm.$u.post("/api/common/search_school", params);
  api.certificateTree = (params = {}) =>
    vm.$u.post("/api/common/certificateTree", params);
  api.saveEducation = (params = {}) =>
    vm.$u.post("/api/resume_user/saveEducation", params);
  api.saveWorkExperience = (params = {}) =>
    vm.$u.post("/api/resume_user/saveWorkExperience", params);
  api.editResume = (params = {}) =>
    vm.$u.post("/api/resume_user/editResume", params);
  api.setDefaultEducation = (params = {}) =>
    vm.$u.post("/api/resume_user/setDefaultEducation", params);
  api.delEducation = (params = {}) =>
    vm.$u.post("/api/resume_user/delEducation", params);

  api.webInfo = (params = {}) => vm.$u.post("/api/common/web_info", params);

  vm.$u.api = api;
};

export default {
  install,
};
